export default __webpack_public_path__ + "static/media/wishlist.86bc0b13.svg";